import React, { useEffect, useState } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import clsx from 'clsx';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './CreateEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    equipment: Yup.array().required()
});

const CreateAreaEquipmentModal = ({
    clearErrors,
    close,
    companyInfo,
    createAreaEquipment,
    equipment,
    errors,
    filteredEquipment,
    isLoading,
    open,
    selectedNode,
    selectedSite,
    title,
    toggleLoading,
    ...props
}) => {

    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (open) {
            const normalized = filteredEquipment.map(({ id }) => id);

            const results = equipment.filter(value => !normalized.includes(value.id));

            setOptions(results);
        }
    }, [open, filteredEquipment]);

    const formik = useFormik({
        initialValues: {
            equipment: []
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {

            let isCreated;
            let equipmentIds = [];

            clearErrors();
            setSubmitting(true);

            equipment.forEach(item => {
                if (values.equipment.includes(item.name)) {
                    equipmentIds.push(item.id);
                }
            });

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    isCreated = await createAreaEquipment(
                        selectedNode.id,
                        selectedSite.id,
                        equipmentIds
                    );
                }

                if (isCreated) {
                    setSubmitting(false);
                    toggleLoading(false);

                    handleClose();
                } else {
                    setSubmitting(false);
                    toggleLoading(false);
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const fixKey = key => {
        const searchRegExp = /\.\$/g;

        return key.replace(searchRegExp, '');
    };

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();
        close();
    };

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onRendered={formik.handleReset}
            onConfirm={formik.handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
            confirmText="Create"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/areaTreeIcon.svg" alt="area icon" />
                        <span>Add Equipment to Area</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            Select the pieces of Equipment to add to Area.
                        </p>
                        <p>
                            Equipment already associated with this Area will not appear in the list.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.fullWidth}>
                            <InputLabel
                                htmlFor="equipment"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment)}
                            >
                                Select Equipment
                            </InputLabel>
                            <Select
                                multiple
                                value={formik.values.equipment}
                                id="equipment"
                                input={<Input id="select-multiple-checkbox" />}
                                renderValue={selected => selected.join(', ')}
                                onChange={formik.handleChange}
                                name="site"
                                classes={{
                                    root: formik.errors.equipment ? clsx(classes.cssErrorUnderline, classes.input) : clsx(classes.cssUnderline, classes.input)
                                }}
                                inputProps={{
                                    name:   'equipment',
                                    id:     'equipment',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment)}
                            >
                                {
                                    options.map(piece => (
                                        <MenuItem
                                            className={classes.selectMenuItem}
                                            value={piece.name}
                                            key={fixKey(piece.id)}
                                        >
                                            <Checkbox
                                                color="primary"
                                                checked={formik.values.equipment.indexOf(piece.name) > -1}
                                            />

                                            <span>{piece.name}</span>
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            {formik.touched.equipment &&
                             formik.errors.equipment && <FormHelperText className={classes.error}>{formik.errors.equipment}</FormHelperText>}
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog >
    );
};

CreateAreaEquipmentModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo:       state.companyInfo,
        equipment:         state.architect.equipment,
        errors:            state.messages.errors,
        filteredEquipment: state.architect.filteredEquipment,
        isLoading:         state.ui.isLoading,
        selectedNode:      state.architect.selectedNode,
        selectedSite:      state.site.selectedSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAreaEquipmentModal);
